import { ChevronRight } from "lucide-react";

/** One of the four stat tiles on a day card (exercises / time / cardio / focus). */
export const DayStatTile = ({ iconSrc, label, value, image, onClick, testId, fill = 68, tone = 'accent', muted }) => {
  const bar = tone === 'done' ? 'var(--accent-muted)' : 'var(--accent-hex)';
  const Wrapper = onClick ? 'button' : 'div';
  return (
    <Wrapper
      {...(onClick ? { type: 'button', onClick } : {})}
      data-testid={testId}
      className={`relative overflow-hidden rounded-2xl border border-white/[0.09] bg-white/[0.04] text-left w-full h-[84px] ${onClick ? 'active:scale-[0.97] transition-transform' : ''}`}
      style={{ boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.07)' }}
    >
      <span className="relative flex items-center gap-2.5 h-full pl-2.5 pr-2.5 pb-2">
        <img src={iconSrc} alt="" aria-hidden="true" loading="lazy" draggable={false}
             className="w-11 h-11 shrink-0 pointer-events-none"
             style={{ filter: muted ? 'grayscale(1) brightness(1.5) opacity(0.5)' : 'grayscale(1) brightness(1.9)' }} />
        <span className="flex-1 min-w-0">
          <span className="block text-[9.5px] font-heading font-bold uppercase tracking-[0.12em] text-white/50 leading-none">{label}</span>
          <span className={`block mt-1 font-heading font-black text-lg leading-none truncate ${muted ? 'text-white/45' : 'text-white'}`}>{value}</span>
        </span>
        {onClick && <ChevronRight size={16} className="text-white/35 shrink-0" />}
      </span>
      <span className="absolute bottom-2.5 left-3 right-3 h-[3px] rounded-full bg-white/[0.12] overflow-hidden">
        <span className="block h-full rounded-full"
              style={{ width: `${muted ? 0 : fill}%`, background: bar, boxShadow: `0 0 8px ${bar}` }} />
      </span>
    </Wrapper>
  );
};
